import fetchProductSpec from "../services/fetchProductSpec";
import { updateProductSpecData } from "../store/globalCatalogManagement.slice";
import * as Sentry from "@sentry/react";
import { waitForSessionTokens } from "./session";

export const fetchProductSpecDetails = async (dispatch: any) => {
  try {
    // Wait for session tokens to be available (up to 3 seconds)
    const tokensAvailable = await waitForSessionTokens();
    
    if (!tokensAvailable) {
      console.warn("Cannot fetch product spec: Authentication tokens not available after waiting");
      return;
    }
    
    const productspec = await fetchProductSpec.getProductSpec();
    const productSpecData = productspec?.data?.result?.data;
    dispatch(updateProductSpecData(productSpecData));
  } catch (error) {
    console.error("Error occured while fetching shop details");
    Sentry.captureException(error);
  }
};
